import { render, staticRenderFns } from "./add_edit.vue?vue&type=template&id=f63164a8&scoped=true&"
import script from "./add_edit.vue?vue&type=script&lang=js&"
export * from "./add_edit.vue?vue&type=script&lang=js&"
import style0 from "./add_edit.vue?vue&type=style&index=0&id=f63164a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63164a8",
  null
  
)

export default component.exports